"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContext = void 0;
const react_1 = __importStar(require("react"));
const Api_1 = __importDefault(require("../services/Api"));
const Loading_1 = __importDefault(require("../components/Loading"));
const lodash_1 = require("lodash");
exports.AppContext = (0, react_1.createContext)({});
const withAppContext = function (Component) {
    return (props) => {
        const [ready, setReady] = (0, react_1.useState)(false);
        const { assets, api_map } = props, otherProps = __rest(props, ["assets", "api_map"]);
        const [apiInstance] = (0, react_1.useState)((0, lodash_1.cloneDeep)(Api_1.default));
        (0, react_1.useEffect)(() => {
            var _a;
            if (api_map) {
                // If we already have a map, then apply it, saving the call to the server.
                apiInstance.applyMap(api_map);
            }
            else {
                // @ts-ignore
                if ((_a = window === null || window === void 0 ? void 0 : window.TBK_APP_CONTEXT) === null || _a === void 0 ? void 0 : _a.api_map) {
                    // @ts-ignore
                    apiInstance.applyMap(window.TBK_APP_CONTEXT.api_map);
                }
            }
            // @ts-ignore
            apiInstance.prepare().then(() => setReady(true));
        }, [apiInstance, api_map]);
        const context = {
            assets,
            Api: apiInstance,
        };
        // An interesting thing here.  Without the <div> wrapper, the way tbk-gutenberg renders this component
        // causes "DOMException: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of
        // this node" because this component is appended to an element that gets replaced.  Having the div at the top
        // means that the component is mounted to that, which is still there after tbk-gutenberg has done the replace.
        // A new pattern to remember....
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(exports.AppContext.Provider, { value: context }, ready ? (
            /* @ts-ignore JSX element type 'Component' does not have any construct or call signatures. */
            react_1.default.createElement(Component, Object.assign({}, otherProps, { context: exports.AppContext }))) : (react_1.default.createElement(Loading_1.default, null)))));
    };
};
exports.default = withAppContext;
